import i18n from "lib/i18n";
import PropTypes from "prop-types";
import React from "react";
import {
  MessageTile,
  MessageTileHeader,
  MessageTileBody,
  MessageTileButton,
  ThemeProvider,
  defaultTheme
} from "@theconversation/ui";


import cc from "./cc.logo.svg";
import styles from "./styles.scss";

const RepublishPanel = ({ onClick }) => (
  <ThemeProvider theme={defaultTheme()}>
    <div className={styles.republishPanel}>
      <MessageTile>
        <MessageTileHeader>
          <img alt="CC BY ND" style={{ width: 100, marginBottom: 16 }} src={cc} />
          <div>{ i18n.t("republish_panel.title") }</div>
        </MessageTileHeader>

        <MessageTileBody>
          { i18n.t("republish_panel.body") }
        </MessageTileBody>

        <MessageTileButton size="small" onClick={onClick}>
          { i18n.t("republish_panel.button_text") }
        </MessageTileButton>
      </MessageTile>
    </div>
  </ThemeProvider>
);

RepublishPanel.defaultProps = {
  onClick: () => {},
};

RepublishPanel.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default RepublishPanel;
